export class Provincia {
  IdProvincia: number;
  IdDepartamento: number;
  Nombre: string;
  Valor: string;
  Estado: number;
  UsuarioCreacion: string;
  FechaCreacion: Date;
  UsuarioModificacion: string;
  FechaModificacion: Date;
}
